// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  font-family: 'Exo', sans-serif;
}

body {
  margin: 0;
  background-color: #f1f1f1;
  font-family: 'Exo', sans-serif;
}

div {
  display: block;
  font-family: 'Exo', sans-serif;
}

.body-new {
  background-color: #4da350;
}

.body-grey {
  background-color: #f1f1f1;
  /* color: #eb4a4a */
}

button {
  cursor: pointer;
}

.list-item-limit-padding {
  padding: 4px;
}

.rotate-icon {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.box-component {
  width: 90%;
  min-width: 250px;
  max-height: 40vh;
  text-align: right;
  overflow: auto;
}

.box-component-text-align-left {
  width: 20vw;
  min-width: 250px;
  max-height: 40vh;
  text-align: left;
  /* overflow: auto; */
}

.pointer {
  cursor: pointer;
}

.justify-content-space-btw {
  justify-content: space-between;
}

.mapboxgl-popup-content {
  max-height: 40vh;
  overflow-y: auto;
}

.slick-list {
  height: 100px;
  z-index: 1;
}

.slick-slide.slick-current {
  z-index: 10;
}

textarea {
  border-color: #E8E8E8 !important;
}

textarea:focus {
  outline: #8BC34A !important;
  border-color: #8BC34A !important;
  box-shadow: 0 0 10px #8BC34A;
}

textarea:hover {
  border-color: #d5d5d5 !important;
}

/* landing page, taken from adapt-oakland.webflow.io */
.adapt-cycle svg {
  width: 100%;
  height: 100%;
}

.adapt-cycle svg path {
  cursor: pointer;
}

.adapt-cycle path.active {
  transition: fill 200ms ease-in;
  animation-fill-mode: forwards;
  animation-duration: 1s;
  animation-name: adapt-cycle-light-on;
  cursor: pointer;
}

.adapt-cycle path.static {
  fill: #7ABF53 !important;
}

.adapt-cycle path.step:hover {
  fill: #7ABF53 !important;
  opacity: 80%;
}

.adapt-cycle text {
  font-family: "Exo", sans-serif;
  font-size: 2.25rem;
  font-weight: 400;
  line-height: 1.167;
  letter-spacing: 0em;
}

.adapt-cycle text.active {
  animation-name: adapt-cycle-text-on;
  animation-fill-mode: forwards;
  animation-duration: 4s;
  animation-delay: 1500ms;
  cursor: pointer;
  pointer-events: none;
}

.adapt-cycle text.static {
  fill: white;
}

.adapt-cycle .step[data-step="1"] {animation-delay: 500ms;}
.adapt-cycle .step[data-step="2"] {animation-delay: 700ms;}
.adapt-cycle .step[data-step="3"] {animation-delay: 900ms;}
.adapt-cycle .step[data-step="4"] {animation-delay: 1100ms;}
.adapt-cycle .step[data-step="5"] {animation-delay: 1300ms;}
.adapt-cycle .step[data-step="6"] {animation-delay: 1500ms;}

@keyframes adapt-cycle-light-on {
  from {
    fill: transparent;
  }
  to {
    fill: #7ABF53;
  }
}

@keyframes adapt-cycle-text-on {
  0% {
    fill: transparent;
  }
  100% {
    fill: white;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 12px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  margin-bottom: 12px;
}

.text-field {
  min-width: fit-content;
  width: '200px';
  padding-top: 3px;
  padding-bottom: 12px;
}

.button-group {
  display: flex;
  gap: 3px;
  padding-bottom: 3px;
  align-items: center;
}

.MuiSlider-markLabel {
  font-size: 0.75rem;
  white-space: nowrap;
  transform: rotate(-45deg);
  transform-origin: top left;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"CAAC;EACC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA,mCAAmC,sBAAsB,CAAC;AAC1D,mCAAmC,sBAAsB,CAAC;AAC1D,mCAAmC,sBAAsB,CAAC;AAC1D,mCAAmC,uBAAuB,CAAC;AAC3D,mCAAmC,uBAAuB,CAAC;AAC3D,mCAAmC,uBAAuB,CAAC;;AAE3D;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B","sourcesContent":[" html {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n  font-family: 'Exo', sans-serif;\n}\n\nbody {\n  margin: 0;\n  background-color: #f1f1f1;\n  font-family: 'Exo', sans-serif;\n}\n\ndiv {\n  display: block;\n  font-family: 'Exo', sans-serif;\n}\n\n.body-new {\n  background-color: #4da350;\n}\n\n.body-grey {\n  background-color: #f1f1f1;\n  /* color: #eb4a4a */\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.list-item-limit-padding {\n  padding: 4px;\n}\n\n.rotate-icon {\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.box-component {\n  width: 90%;\n  min-width: 250px;\n  max-height: 40vh;\n  text-align: right;\n  overflow: auto;\n}\n\n.box-component-text-align-left {\n  width: 20vw;\n  min-width: 250px;\n  max-height: 40vh;\n  text-align: left;\n  /* overflow: auto; */\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.justify-content-space-btw {\n  justify-content: space-between;\n}\n\n.mapboxgl-popup-content {\n  max-height: 40vh;\n  overflow-y: auto;\n}\n\n.slick-list {\n  height: 100px;\n  z-index: 1;\n}\n\n.slick-slide.slick-current {\n  z-index: 10;\n}\n\ntextarea {\n  border-color: #E8E8E8 !important;\n}\n\ntextarea:focus {\n  outline: #8BC34A !important;\n  border-color: #8BC34A !important;\n  box-shadow: 0 0 10px #8BC34A;\n}\n\ntextarea:hover {\n  border-color: #d5d5d5 !important;\n}\n\n/* landing page, taken from adapt-oakland.webflow.io */\n.adapt-cycle svg {\n  width: 100%;\n  height: 100%;\n}\n\n.adapt-cycle svg path {\n  cursor: pointer;\n}\n\n.adapt-cycle path.active {\n  transition: fill 200ms ease-in;\n  animation-fill-mode: forwards;\n  animation-duration: 1s;\n  animation-name: adapt-cycle-light-on;\n  cursor: pointer;\n}\n\n.adapt-cycle path.static {\n  fill: #7ABF53 !important;\n}\n\n.adapt-cycle path.step:hover {\n  fill: #7ABF53 !important;\n  opacity: 80%;\n}\n\n.adapt-cycle text {\n  font-family: \"Exo\", sans-serif;\n  font-size: 2.25rem;\n  font-weight: 400;\n  line-height: 1.167;\n  letter-spacing: 0em;\n}\n\n.adapt-cycle text.active {\n  animation-name: adapt-cycle-text-on;\n  animation-fill-mode: forwards;\n  animation-duration: 4s;\n  animation-delay: 1500ms;\n  cursor: pointer;\n  pointer-events: none;\n}\n\n.adapt-cycle text.static {\n  fill: white;\n}\n\n.adapt-cycle .step[data-step=\"1\"] {animation-delay: 500ms;}\n.adapt-cycle .step[data-step=\"2\"] {animation-delay: 700ms;}\n.adapt-cycle .step[data-step=\"3\"] {animation-delay: 900ms;}\n.adapt-cycle .step[data-step=\"4\"] {animation-delay: 1100ms;}\n.adapt-cycle .step[data-step=\"5\"] {animation-delay: 1300ms;}\n.adapt-cycle .step[data-step=\"6\"] {animation-delay: 1500ms;}\n\n@keyframes adapt-cycle-light-on {\n  from {\n    fill: transparent;\n  }\n  to {\n    fill: #7ABF53;\n  }\n}\n\n@keyframes adapt-cycle-text-on {\n  0% {\n    fill: transparent;\n  }\n  100% {\n    fill: white;\n  }\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  margin-bottom: 12px;\n}\n\n.text-field {\n  min-width: fit-content;\n  width: '200px';\n  padding-top: 3px;\n  padding-bottom: 12px;\n}\n\n.button-group {\n  display: flex;\n  gap: 3px;\n  padding-bottom: 3px;\n  align-items: center;\n}\n\n.MuiSlider-markLabel {\n  font-size: 0.75rem;\n  white-space: nowrap;\n  transform: rotate(-45deg);\n  transform-origin: top left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
